import React, { useState } from "react";
import QC from "../QC";
import MarkSampleQCModal from "../MarkSampleQCModal/components/MarkSampleQCModal";

import "./QcHistory.css";
import "../QC.css";

export default function QcHistory() {
  const [selectedRecord, setSelectedRecord] = useState(null);
  return (
    <>
      <QC
        source="QC"
        readOnly
        onRowClick={(rowRecord) => {
          setSelectedRecord(rowRecord);
        }}
      />
      {selectedRecord && (
        <MarkSampleQCModal
          open
          rowData={selectedRecord}
          readOnly
          onCancel={() => setSelectedRecord(null)}
        />
      )}
    </>
  );
}
